var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJUnit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dc514a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.99684
    },
    d: "M64.166 2.191c-15.303-.292-29.9 3.746-42.39 15.293-26.137 24.174-26.915 65.564-1.67 90.63 4.544 4.512 9.952 8.686 15.89 11.228 1.551-5.215 1.249-11.511.758-17.7-.118-.122-.24-.243-.33-.378-1.659-2.473-.428-8.929-.428-11.866 10.436 1.85 18.936 7.59 30.108 4.256 10.933-3.263 15.49-19.03 5.851-26.494-5.821-4.51-14.457-3.895-21.322-3.068-4.123.498-9.271 2.02-12.117-2.365-1.68-2.581.054-8.916.336-11.836.07-.736.147-1.486.22-2.225.731-9.068 1.944-18.234 1.944-27.307H85.34V4.975C78.224 3.35 71.122 2.325 64.166 2.19z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#23a161",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.998488
    },
    d: "M84.982 4.947v27.08H52.729l-1.676 20.827c7.157-.561 13.792-1.824 20.944-.143 4.903 1.155 9.505 3.47 12.91 7.227C94.41 70.41 92.54 90.068 81.63 98.9c-3.07 2.486-6.578 4.119-10.282 5.169-3.42 1.093-6.856 1.556-10.304 1.588a70.94 70.94 0 0 1-3.708.104c-5.37 0-10.741-.698-15.917-2.146-1.316-.369-3.352-.882-4.632-1.84-.271-.058-.543-.121-.814-.18l-.417 17.497c33.24 17.626 75.585-1.233 87.508-35.825 10.079-29.233-5.53-70.647-38.082-78.32Z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJUnit);
export default __webpack_public_path__ + "static/media/JUnit.413d99929d684d2a01c954771a489610.svg";
export { ForwardRef as ReactComponent };